import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

@Injectable()
export class JsonService {
  public headers = new Headers({ 'Content-Type': 'application/json'});
  public options = new RequestOptions({ headers: this.headers });
  public path: string;
  constructor(
    public http: Http) {
  }

  ngOnInit(): void {
  }

  getpath(): string {
    return this.path;
  }

  setpath(path: string) {
    this.path = path;
  }

  getJson(): Observable<any> {
    return this.http.get(this.path, this.options)
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  public extractData(res: Response): any {
    /*let body: any = res.json();
    return body;*/
  }

  public handleError(error: any) {
    const body: Error  = error._body;
    return Observable.throw(body);
  }
}
